import { render, staticRenderFns } from "./GuestOrderDetailsDialog.vue?vue&type=template&id=b81b2056&scoped=true"
import script from "./GuestOrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./GuestOrderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./GuestOrderDetailsDialog.vue?vue&type=style&index=0&id=b81b2056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81b2056",
  null
  
)

export default component.exports